import { breakpoints, colors, desktopHeaderHeight } from "../shared";

const profileMenuTopMargin = 5;
const marginForSearchContainer = desktopHeaderHeight / 2;
const marginTopSearchContainerRemToPx = 26;
const negativeSearchContainerMargin =
    -marginForSearchContainer +
    marginTopSearchContainerRemToPx -
    profileMenuTopMargin;

export const animateScrollingDown = ({
    navRef,
    searchContainerRef,
    navLinkRef,
    profileMenuRef,
    isHeroSearch,
    heroSearchBgColor,
    siteHeaderRef,
    isHeroSearchV2
}) => {
    if (navRef && navRef.current) {
        navRef.current.style.opacity = "0";
        searchContainerRef.current.style.marginTop = `${negativeSearchContainerMargin}px`;
        navLinkRef.current.setAttribute("aria-hidden", "true");
        profileMenuRef.current.style.marginTop = `${profileMenuTopMargin}px`;
        isHeroSearch &&
            (siteHeaderRef.current.style.background = colors.whiteDuplicate);
        isHeroSearch &&
            (siteHeaderRef.current.style.borderBottom = "1px solid #d8d8d8");
        heroSearchBgColor &&
            (siteHeaderRef.current.style.background = colors.whiteDuplicate);
        // adds & removes header classes based on scroll so we control styles via CSS:
        isHeroSearchV2 && siteHeaderRef.current.classList.add("scrolledDown");
        isHeroSearchV2 && siteHeaderRef.current.classList.remove("scrolledUp");
    }
};

export const animateScrollingBackUp = ({
    navRef,
    searchContainerRef,
    navLinkRef,
    profileMenuRef,
    isHeroSearch,
    heroSearchBgColor,
    siteHeaderRef,
    isHeroSearchV2
}) => {
    if (navRef && navRef.current) {
        navRef.current.style.opacity = "1";
        searchContainerRef.current.style.marginTop = "0";
        navLinkRef.current.setAttribute("aria-hidden", "false");
        profileMenuRef.current.style.marginTop = "0";

        isHeroSearch && (siteHeaderRef.current.style.background = colors.white);
        // ^^ this color is specific to the current interim home page; when we refactor for new home page/landing page, we should pass in a color depending on what color we will need for a hero.
        isHeroSearch && (siteHeaderRef.current.style.borderBottom = "0");
        heroSearchBgColor &&
            (siteHeaderRef.current.style.background = heroSearchBgColor);
        // adds & removes header classes based on scroll so we control styles via CSS:
        isHeroSearchV2 && siteHeaderRef.current.classList.remove("scrolledDown");
        isHeroSearchV2 && siteHeaderRef.current.classList.add("scrolledUp");
    }
};

// helpers for animations:
import {
    scrollToDesktopWithHero,
    scrollToTabletWithHero,
    scrollToMobileWithHero,
    scrollToDesktopNoHero,
    scrollToDesktopHeroSearchBar,
    scrollToTabletHeroSearchBar,
    scrollToMobileHeroSearchBar
} from "../shared";

const tabletBreakpoint = breakpoints.beforeTabletPx;
const desktopBreakpoint = breakpoints.beforeDesktopPx;

export const scrollPosAnimation = ({ browserWidth, isHeroSearchV2 }) => {
    let animateHeaderScrollPos;

    if (browserWidth > desktopBreakpoint) {
        // desktop scroll position:
        animateHeaderScrollPos = scrollToDesktopWithHero;
    } else if (browserWidth > tabletBreakpoint) {
        // tablet scroll position:
        animateHeaderScrollPos = scrollToTabletWithHero;
    } else {
        // mobile scroll position:
        animateHeaderScrollPos = scrollToMobileWithHero;
    }

    return isHeroSearchV2 ? animateHeaderScrollPos : scrollToDesktopNoHero;
    // TODO: BEFORE MERGE MAKE SURE THIS DOES NOT MESS UP isHeroSearch (original/current home page)
};

export const scrollPosShowHideSearch = ({ browserWidth, isHeroSearchV2 }) => {
    let showHideHeroScrollPos;

    if (browserWidth > desktopBreakpoint) {
        // desktop scroll position:
        showHideHeroScrollPos = scrollToDesktopHeroSearchBar;
    } else if (browserWidth > tabletBreakpoint) {
        // tablet scroll position:
        showHideHeroScrollPos = scrollToTabletHeroSearchBar;
    } else {
        // mobile scroll position:
        showHideHeroScrollPos = scrollToMobileHeroSearchBar;
    }

    return isHeroSearchV2 ? showHideHeroScrollPos : 0;
};

export const scrollSearchBarScrollingDown = ({
    heroSearchWrapper,
    isHeroSearchV2,
    searchWrapperRef
}) => {
    if (searchWrapperRef && searchWrapperRef.current) {
        isHeroSearchV2 &&
        (searchWrapperRef.current.querySelector("form").style.display =
            "block");
        isHeroSearchV2 &&
        (searchWrapperRef.current.querySelector("svg").style.display = "block");
    }

    if (heroSearchWrapper) {
        isHeroSearchV2 && (heroSearchWrapper.style.display = "none");
    }
};

export const scrollSearchBarScrollingUp = ({
    heroSearchWrapper,
    isHeroSearchV2,
    searchWrapperRef
}) => {
    if (searchWrapperRef && searchWrapperRef.current) {
        isHeroSearchV2 &&
        (searchWrapperRef.current.querySelector("form").style.display = "none");
        isHeroSearchV2 &&
            (searchWrapperRef.current.querySelector("svg").style.display = "none");
    }

    if (heroSearchWrapper) {
        isHeroSearchV2 && (heroSearchWrapper.style.display = "block");
    }
};
